export const META_ENTITY_KIND = 'meta_entity_edit/v1';
export const metaEntityEditable = row => row?.platform === 'meta' && ['ad_set','ad'].includes(row.entityType)
  && typeof row.entityId === 'string' && /^\d{1,20}$/.test(row.entityId) && row.settings?.id === row.entityId
  && ['ACTIVE','PAUSED'].includes(row.settings?.status);
export const entitySelectionLabel = type => ({keyword:'keywords',ad_group:'ad groups',ad_set:'ad sets',ad:'ads'}[type] || 'entities');
